"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestClient = void 0;
const axios_1 = __importDefault(require("axios"));
const axios_2 = require("axios");
// Request clients wraps the axios client and handles error responses
class RequestClient {
    constructor(baseURL) {
        this.httpClient = axios_1.default.create({
            baseURL,
        });
    }
    get(path, params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpClient.get(path, {
                    params,
                });
                return response.data;
            }
            catch (error) {
                if (error instanceof axios_2.AxiosError && ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message)) {
                    throw new Error(error.response.data.message);
                }
                throw error;
            }
        });
    }
    post(path, data = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpClient.post(path, data);
                return response.data;
            }
            catch (error) {
                if (error instanceof axios_2.AxiosError && ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message)) {
                    throw new Error(error.response.data.message);
                }
                throw error;
            }
        });
    }
}
exports.RequestClient = RequestClient;
//# sourceMappingURL=request-client.js.map